// 存cookie
export function setCookieAmend(key, value, isDoNotTrans) {
  // 设置过期原则
  const Days = 3650; // 默认保留10年
  const exp = new Date(); // 计算过期时间
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  if (document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com') {
    if (isDoNotTrans) {
      document.cookie = `${key}=${value};expires=${exp.toString()};domain=.iflix.com;path=/`;
    } else {
      document.cookie = `${key}=${escape(value)};expires=${exp.toString()};domain=.iflix.com;path=/`;
    }
  } else {
    if (isDoNotTrans) {
      document.cookie = `${key}=${value};expires=${exp.toString()};domain=.wetv.vip;path=/`;
    } else {
      document.cookie = `${key}=${escape(value)};expires=${exp.toString()};domain=.wetv.vip;path=/`;
    }
  }
}
// 获取cookie
export function getCookieAmend(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return unescape(arr[2]);
  }
  return null;
}
// 删除cookie
export function delCookieAmend(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cval = getCookieAmend(name);
  if (cval !== null) {
    document.cookie = `${name}=${cval};expires=${exp.toGMTString()}`;
  }
}
// 存sessionStorage
export function setCookie(key, value) {
  let currentVal = value;
  if (!key) return;
  currentVal = JSON.stringify(currentVal);
  sessionStorage.setItem(key, currentVal);
}
// 获取sessionStorage
export function getCookie(name) {
  return JSON.parse(sessionStorage.getItem(name));
}
// 删除sessionStorage
export function delCookie(name) {
  sessionStorage.removeItem(name);
}

// 存LocalStorage
export function setLocalStorage(key, value) {
  let currentVal = value;
  if (!key) return;
  currentVal = JSON.stringify(currentVal);
  localStorage.setItem(key, currentVal);
}
// 获取LocalStorage
export function getLocalStorage(name) {
  return JSON.parse(localStorage.getItem(name));
}
// 删除LocalStorage
export function delLocalStorage(name) {
  localStorage.removeItem(name);
}

// 清除所有cookie函数
export function clearAllCookie() {
  const keys = document.cookie.match(/[^ =;]+(?==)/g);
  // clearAllcookie在登录态失效时以及退出登录时会执行，清除用户的信息以及状态
  // guid信息和countryCode信息不用清除, 由于清除了country_code之后，开通会员二维码获取会失败
  const whiteArr = ['guid', 'country_code'];
  if (keys) {
    for (let i = 0; i < keys.length; i++) {
      if (document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com') {
        if (!whiteArr.includes(keys[i])) {
          document.cookie = `${keys[i]}=0;expires=${new Date(0).toUTCString()};domain=.iflix.com;path=/`;
        }
      } else {
        if (!whiteArr.includes(keys[i])) {
          document.cookie = `${keys[i]}=0;expires=${new Date(0).toUTCString()};domain=.wetv.vip;path=/`;
        }
      }
    }
  }
}
